import React from "react";
import { FaShoppingBasket } from "react-icons/fa";
import { Spinner } from "react-rainbow-components";
import ModalCreateProduct from "../../components/productSettingComponent/ModalCreateProduct";
import { IProduct } from "../../interfaces/product";
import { Container, HeaderTitle } from "./index.style";
import { getProduct } from "../../services/product.service";
import { useError } from "../../store/ErrorModal";
import CardProductComponent from "../../components/productSettingComponent/CardProductComponent";
import CardAddProduct from "../../components/productSettingComponent/CardAddProduct";

export default function ProductSettingPage() {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [data, setData] = React.useState<IProduct[]>([]);
  const handalClickCreateProduct = () => setIsOpen(true);
  const { onError } = useError();
  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getProduct();
      setData(res.data);
    } catch (error) {
      onError(error as any);
    }
    setIsLoading(false);
  }, [onError]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Container>
      {!isLoading ? (
        <>
          <ModalCreateProduct
            fetchData={fetchData}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
          <HeaderTitle style={{ width: "100%" }}>
            <FaShoppingBasket size="2rem" />
            <h1>จัดการโปรโมชั่นสินค้า</h1>
          </HeaderTitle>
          <CardAddProduct onClick={handalClickCreateProduct} />
          {data.map((item, index) => (
            <CardProductComponent
              fetchData={fetchData}
              item={item}
              key={index}
            />
          ))}
        </>
      ) : (
        <div>
          <Spinner size="large" variant="brand" />
        </div>
      )}
    </Container>
  );
}
